import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/manage-connect';

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/channelConnectAccounts`, {
		status: 0,
	});
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/channelConnectAccounts/${id}`, { merchantId });
};

const connect = (
	merchantId,
	refreshUrl,
	returnUrl,
	operateBy,
	branchId = '',
	paymentChannel = 'Stripe'
) => {
	return Client.post(`${baseUrl}/${merchantId}/connectAccounts`, {
		refreshUrl,
		returnUrl,
		paymentChannel,
		branchId,
		operateBy,
	});
};

// const remove = (merchantId, id, operateBy) => {
// 	return Client.del(`${baseUrl}/${merchantId}/channelConnectAccounts/${id}`, {
// 		operateBy,
// 	});
// };

const disconnect = (merchantId, id, operateBy, branchId = '') => {
	return Client.post(
		`${baseUrl}/${merchantId}/disconnectChannelAccount/${id}`,
		{
			branchId,
			operateBy,
		}
	);
};

const auth = (
	merchantId,
	authCode,
	operateBy,
	branchId = '',
	paymentChannel = 'Stripe'
) => {
	return Client.post(
		`${baseUrl}/${merchantId}/channelConnectAccounts/authorized`,
		{
			authCode,
			paymentChannel,
			branchId,
			operateBy,
		}
	);
};

const deauth = (merchantId, id, operateBy, branchId = '') => {
	return Client.post(
		`${baseUrl}/${merchantId}/channelConnectAccounts/deAuthorized/${id}`,
		{
			branchId,
			operateBy,
		}
	);
};

const login = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/account/login/link`, {
		branchId,
	});
};

export default {
	list,
	find,
	connect,
	// remove,
	disconnect,
	auth,
	deauth,
	login,
};
